import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import {
  buildThemeHref,
  getDiscoveryTheme,
  getThemeMenuItems,
  readDiscoveryTheme,
} from '../lib/discoveryThemes';
import { ThemeSwitch } from './Theme/ThemeSwitch';

export const Navigation = () => {
  const location = useLocation();
  const activeTheme = readDiscoveryTheme(location.search);
  const themeConfig = getDiscoveryTheme(activeTheme);
  const navItems = getThemeMenuItems(activeTheme, location.search);

  return (
    <header className="atlas-nav-shell">
      <div className="atlas-nav">
        <Link className="atlas-brand" to={buildThemeHref('/', location.search, activeTheme, { page: null, q: null })}>
          <span className="atlas-brand-mark">TW</span>
          <span>
            <strong>Tellus</strong>
            <small>{themeConfig.brandSubtitle}</small>
          </span>
        </Link>

        <div className="atlas-nav-links">
          <ThemeSwitch className="atlas-theme-switch--nav" />
          <nav aria-label="Primary">
            {navItems.map((item) => (
              <NavLink
                key={item.key}
                to={item.to}
                className={({ isActive }) =>
                  `atlas-nav-link ${isActive ? 'is-active' : ''}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};
